import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';
import CustomDropdown from '@components/CustomDropdown';

import { PAIR_FABRIC, PAIR_TRIMS } from '@features/materials/MaterialConstants';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { addPairMaterial, getFabricReferenceList } from '@services/materialService';

const AddMatchingFabricTrimsModal = ({
	primaryMaterialId,
	referenceNumber,
	onAddSuccess,
	type,
	onCloseModal
}) => {
	const [pairFabricList, setPairFabricList] = useState([]);
	const [searchPairFabric, setSearchPairFabric] = useState('');
	const [pairFabricCode, setPairFabricCode] = useState(null);
	const [pairFabricSubCategory, setPairFabricSubCategory] = useState(null);
	const dispatch = useDispatch();

	const getAllFabricReferanceList = async () => {
		dispatch(openLoader());
		const params = {
			page: 0,
			size: 20,
			supplierType: type.toUpperCase(),
			sortInMaterialList: true,
			nitexReferenceNumber: searchPairFabric
		};
		const response = await getFabricReferenceList(params);
		const filteredResponse = response.filter((item) => item.referenceNumber !== referenceNumber);
		setPairFabricList(filteredResponse);
		dispatch(closeLoader());
	};

	const onSearchPairFabric = (key) => {
		setSearchPairFabric(encodeURI(key));
	};

	useEffect(() => {
		getAllFabricReferanceList();
	}, [searchPairFabric]);

	const onSubmit = async () => {
		dispatch(openLoader());
		const responseData = await addPairMaterial(
			primaryMaterialId,
			pairFabricSubCategory?.id,
			pairFabricCode?.id
		);
		if (responseData) {
			onAddSuccess();
		}
		dispatch(closeLoader());
	};
	return (
		<ModalContainer className="add-pair-modal" onCloseModal={() => {}}>
			<div className="common-popup">
				<ModalHeader title={`Connect Matching ${type}`} onClose={onCloseModal} />
				<div className="common-popup-body">
					<div className="form-group pair-fabric-code">
						<div className="form-group size36">
							<label htmlFor="pairFabricCode">
								Matching {type} Type (
								{type === 'Fabric' ? 'Rib, Collar, Cuff etc' : 'Tape, Drawcord etc'})*
							</label>
							<CustomDropdown
								type="fabricName"
								title={'Select'}
								items={type === 'Fabric' ? PAIR_FABRIC : PAIR_TRIMS}
								toolTipLength={13}
								isShowSearch={false}
								onItemClick={(item) => setPairFabricCode(item)}
								selectedItem={pairFabricCode?.value}
							/>
						</div>

						<div className="form-group size36 mb-0">
							<label htmlFor="pairFabricCode">{type} Reference no*</label>
							<CustomDropdown
								type="fabricName"
								title={'Select'}
								items={pairFabricList}
								onItemClick={(item) => setPairFabricSubCategory(item)}
								selectedItem={pairFabricSubCategory?.value}
								toolTipLength={30}
								onItemSearch={onSearchPairFabric}
							/>
						</div>
					</div>
				</div>
				<div className="modal-footer pt-0">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32 ml-2" onClick={onCloseModal}>
							Cancel
						</button>
						<button
							className="button size32 ml-2"
							onClick={onSubmit}
							disabled={!pairFabricCode || !pairFabricSubCategory}
						>
							Submit
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default AddMatchingFabricTrimsModal;
